import { render } from "./new-banner-with-image-block.vue?vue&type=template&id=368b1890"
import script from "./new-banner-with-image-block.vue?vue&type=script&lang=js"
export * from "./new-banner-with-image-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__